import { Button, Image } from "antd";
import dayjs from "dayjs";
import { useState } from "react";
import { AiOutlineEdit } from "react-icons/ai";
import { GoHeart } from "react-icons/go";
import { LuPhone } from "react-icons/lu";
import { MdOutlineMailOutline } from "react-icons/md";
import AddTeamMember from "../../teamMember/creatTeamMember/AddTeamMember";
import { useParams } from "react-router-dom";
type Props = { data: any };

const TeamMemberProfileCard = ({ data }: Props) => {
  const locationId = useParams()?.salonName;
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  return (
    <div className="flex flex-col">
      <div className="flex justify-end">
        <Button
          type="text"
          htmlType="button"
          onClick={() => setIsEditModalOpen(true)}
          className="W-fit flex items-center  text-[#75757E]  gap-1 px-4 py-1"
        >
          <AiOutlineEdit className="text-color-primary flex items-center text-lg justify-center text-center " />{" "}
          <span className="text-sm">Edit</span>
        </Button>
      </div>
      <div className="mb-4">
        <Image
          preview={false}
          width={115}
          height={115}
          className="rounded-full border-4 border-solid border-white object-cover"
          src={data?.media}
        />
      </div>

      <h3 className="text-color-primary font-semibold text-xl mb-2">
        {data?.name}
      </h3>
      <div className="flex flex-col gap-2 mb-6">
        <div className="flex items-center gap-2">
          <div className="flex items-center gap-2">
            <GoHeart className="text-black flex items-center" />
            <span className="text-[#9999A7] text-sm font-normal truncate max-w-[10rem]">
              {/* {data?.service_categories?.map((e: any, index: number) => (
              <React.Fragment key={index}>
                <span className="mx-1">{e?.name}</span>
                {index < data?.service_categories?.length - 1 && ", "}
              </React.Fragment>
            ))} */}
              {data?.title}
            </span>
          </div>
          <div className="flex items-center gap-2">
            <GoHeart className="text-[#A62727] flex items-center" />
            <span className="text-[#9999A7] text-sm font-normal">
              899 Reviews
            </span>
          </div>
        </div>
        <div className="flex flex-col items-start justify-start w-full gap-1">
          <span className="text-[#75757E] text-sm font-medium">
            Joined {dayjs(data?.start_date).format("MMM. YYYY")}
          </span>
        </div>
      </div>
      <div className="flex flex-col gap-4 justify-self-start w-full h-full">
        <div className="flex items-center gap-2">
          <MdOutlineMailOutline className="flex items-center text-white bg-color-primary w-[25px] h-[25px] p-1 rounded-lg" />
          <span className="text-color-primary text-sm font-normal ">
            {data?.email}
          </span>
        </div>
        <div className="flex items-center gap-2">
          <LuPhone className="flex items-center text-color-primary bg-[#EEF0FF] rounded-lg w-[25px] h-[25px] p-1 " />
          <span className="text-color-primary text-sm font-normal">
            {data?.phone}
          </span>
        </div>
      </div>
      {locationId ? (
        <AddTeamMember
          visible={isEditModalOpen}
          onClose={() => setIsEditModalOpen(false)}
          config={{
            isAdmin: true,
            locationId: +locationId,
            locationName: data?.locations[0]?.name,
            isEdit: true,
            salonName: data?.locations[0]?.name,
            teamMemberId: data?.id,
            salonId: data?.locations[0]?.salon_id!,
          }}
        />
      ) : null}
    </div>
  );
};

export default TeamMemberProfileCard;
